import { SpreadsheetGrid } from "@components/spreadsheet/SpreadsheetGrid";
import { ColumnDef, SpreadsheetRowData } from "@components/spreadsheet/types";
import { ExpandCollapseAllButton } from "@components/tasks/TaskBody/shared/ExpandCollapseAllButton";
import { useExpandCollapseAll } from "@components/tasks/TaskBody/shared/useExpandCollapseAll";
import styles from "./TemplateReportGrid.module.scss";

interface Props {
    rows: SpreadsheetRowData[];
    columns: ColumnDef[];
    expandState: ReturnType<typeof useExpandCollapseAll>;
}

export const TemplateReportGrid = ({ rows, columns, expandState }: Props) => {
    const {
        setExpandedIds,
        expandedIdsSeed,
        isCollapsed,
        handleExpandAll,
        handleCollapseAll,
    } = expandState;

    return (
        <div className={styles.container}>
            <div className={styles.toolbar}>
                <ExpandCollapseAllButton
                    isCollapsed={isCollapsed}
                    onExpandAll={handleExpandAll}
                    onCollapseAll={handleCollapseAll}
                />
            </div>
            <div className={styles.tableWrapper}>
                <SpreadsheetGrid
                    data={rows}
                    columns={columns}
                    expandable
                    defaultExpandedIds={expandedIdsSeed}
                    nestingIndentPx={30}
                    overflow="auto"
                    stickyHeader
                    readonly
                    disableDragFill
                    noOuterBorder
                    onExpandedChange={setExpandedIds}
                />
            </div>
        </div>
    );
};
